import es from "./locales/es.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import ru from "./locales/ru.json";

const legacyResources = {
  es: es.legacy || {},
  en: en.legacy || {},
  de: de.legacy || {},
  ru: ru.legacy || {},
};

const legacyKeys = new Set(
  Object.values(legacyResources).flatMap((resource) => Object.keys(resource))
);

const getLegacyValue = (language, key) =>
  legacyResources[language]?.[key] ||
  legacyResources.es?.[key] ||
  legacyResources.en?.[key] ||
  key;

export const translations = Array.from(legacyKeys).reduce((output, key) => {
  output[key] = {
    es: getLegacyValue("es", key),
    en: getLegacyValue("en", key),
    de: getLegacyValue("de", key),
    ru: getLegacyValue("ru", key),
  };
  return output;
}, {});
